import { createAsyncThunk } from "@reduxjs/toolkit";
import AxiosDefaultSetting from "../AxiosDefault";

//get code_book data
export const getAllCodeBook = createAsyncThunk(
  "codebook/getcodebook",
  async (data, { rejectWithValue }) => {
    const { order_type, order_by, page_size, page, search_text, ...rest } =
      data;
    const queryString = new URLSearchParams({
      order_type,
      order_by,
      page_size,
      page,
      search_text,
    }).toString();
    try {
      const response = await AxiosDefaultSetting({
        method: "GET",
        url: `/codebooks?${queryString}`, //endpoint
        data: data,
      });
      return response.data;
    } catch (error) {
      return rejectWithValue(error?.response?.data?.message);
    }
  }
);

//get code_book options
export const getAllCodeBookOptions = createAsyncThunk(
  "codebook/getCodebookOptions",
  async ({ id, data }, { rejectWithValue }) => {
    const { order_type, order_by, page_size, page, search_text, ...rest } =
      data;
    const queryString = new URLSearchParams({
      order_type,
      order_by,
      page_size,
      page,
      search_text,
    }).toString();
    try {
      const response = await AxiosDefaultSetting({
        method: "GET",
        url: `/codebook-options/${id}?${queryString}`, //endpoint
        data: data,
      });
      return response.data;
    } catch (error) {
      return rejectWithValue(error?.response?.data?.message);
    }
  }
);
//add codebook options

export const addCoodBookOptions = createAsyncThunk(
  "codebook/addcodebookoptions",
  async (data, { rejectWithValue }) => {
    try {
      const response = await AxiosDefaultSetting({
        method: "POST",
        url: `/codebook-options`, //endpoint
        data: data,
      });
      return response.data;
    } catch (error) {
      return rejectWithValue(error?.response?.data?.message);
    }
  }
);

//updateadd book data

export const updateCoodBookOptions = createAsyncThunk(
  "codebook/updatecodebookoptions",
  async ({ id, data }, { rejectWithValue }) => {
    try {
      const response = await AxiosDefaultSetting({
        method: "PUT",
        url: `/codebook-options/${id}`, //endpoint
        data: data,
      });
      return response.data;
    } catch (error) {
      return rejectWithValue(error?.response?.data?.message);
    }
  }
);

//delete codebook  options data
export const deletecodebook = createAsyncThunk(
  "comapny/delete",
  async (id, { rejectWithValue }) => {
    try {
      const response = await AxiosDefaultSetting({
        method: "DELETE",
        url: `/codebook-options/${id}`, //endpoint
      });
      return response.data;
    } catch (error) {
      return rejectWithValue(error?.response?.data?.message);
    }
  }
);

export const getCodebookOptionsByType = createAsyncThunk(
  "org/getCodebookOptionsByType",
  async (data, { rejectWithValue }) => {
    try {
      const response = await AxiosDefaultSetting({
        method: "GET",
        url: `/codebooks/${data.type}`, // dynamic endpoint based on the type passed in
      });
      return { type: data.type, data: response.data };
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);
